import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseProgressBarService } from './progress-bar.service';

@Component({
  standalone: true,
  imports: [MatProgressBarModule],
  selector: 'fuse-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FuseProgressBarComponent implements OnInit, OnDestroy {
  bufferValue: number;
  mode: 'determinate' | 'indeterminate' | 'buffer' | 'query';
  value: number;
  visible: boolean;

  private _unsubscribeAll: Subject<any>;

  constructor(private _fuseProgressBarService: FuseProgressBarService) {
    // Set the defaults

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    // Buffer value
    this._fuseProgressBarService.bufferValue.pipe(takeUntil(this._unsubscribeAll)).subscribe(bufferValue => {
      this.bufferValue = bufferValue;
    });

    // Mode
    this._fuseProgressBarService.mode.pipe(takeUntil(this._unsubscribeAll)).subscribe(mode => {
      this.mode = mode;
    });

    // Value
    this._fuseProgressBarService.value.pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
      this.value = value;
    });

    // Visible
    this._fuseProgressBarService.visible.pipe(takeUntil(this._unsubscribeAll)).subscribe(visible => {
      this.visible = visible;
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
}
